<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp; Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="quickSearch" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="0">
              <a-collapse-panel key="0">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-date-picker placeholder="Select Date" v-model="filter.searchDate" format="DD-MMM-YYYY" allowClear />
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" title="Pencairan Financing KMK" :disabledCreateEditLink="true"
        manifestLink="SpclManifestPenarikanFinancing" :dataList="datasource"
        :isTransactional="true">
      </DataList>
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import CurrencyFormat from "@/mixins/CurrencyFormat";

export default {
  name: "penarikan-financing",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: false,
      rawData: [],
      filter: {
        searchDate: null,
      },
      quickSearch: "",
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getListFinancing",
      "getDefaultDateFormat",
      "getStandartFormatDate",
      "getStatus",
    ]),
    datasource() {
      let outputData = this.rawData;

      if (this.quickSearch) {
        outputData = _.filter(
          outputData,
          (obj) =>
            obj.keyword &&
            obj.keyword.toLowerCase().indexOf(this.quickSearch.toLowerCase()) >=
            0
        );
      }

      if (this.filter.searchDate) {
        let filter = moment(this.filter.searchDate).format(
          this.getDefaultDateFormat
        );
        console.log(filter);
        outputData = _.filter(
          outputData,
          (obj) => obj.tanggal_permohonan === filter
        );
      }

      return outputData;
    },
  },
  mounted() {
    this.fetch();
    this.$store.commit("setInitialState");
  },
  methods: {
    moment,
    fetch() {
      this.$store
        .dispatch("getListPenarikanFinancing", { auth: this.getAuth })
        .then((res) => {
          res.forEach((data) => {
            this.rawData.push({
              id: data.id_penarikan_financing,
              title: data.no_transaksi+" | "+data.tlc_create,
              keyword:
                data.no_transaksi + " | "+data.tlc_create +
                  " " +
                  data.description +
                  " " +
                  data.tlc_create +
                  " " +
                  data.value_pencairan +
                  " " +
                  data.no_kontrak ? data.no_kontrak : "Non Sales Contract",
              subtitle: data.no_kontrak ? data.no_kontrak : "Non Sales Contract",
              tanggal_permohonan: data.tanggal_permohonan,
              subdesc: [
                data.description,
                data.tanggal_permohonan,
                this.formatCurrency("", data.value_pencairan),
              ],
              islistPPrevised: false,
              is_uploaded: data.upload_sts === "yet uploaded" ? "0" : "1",
              onlyFileUploaded: true,
            });
          });
        });
    },
  },
};
</script>

<style></style>
